/**
 * Send custom errors to Datadog RUM
 */
export const addDDError = (error: Error, additionalInfo?: object) => {
  if ((window as any).DD_RUM) {
    (window as any).DD_RUM.onReady(() => {
      (window as any).DD_RUM.addError(error, additionalInfo);
    });
  }
};
